import { PRMarinaNode } from '@sketch-hq/sketch-web-renderer'

/**
 * The UUID of the nearest Section containing this node, or null when it sits
 * directly on the page. Sections can nest to any depth, so this is what makes
 * two Sections siblings: they share the same nearest Section ancestor.
 */
export function getNearestSectionAncestorUUID(
  node: PRMarinaNode | null
): string | null {
  let ancestor = node?.getParentNode() ?? null

  while (ancestor && !ancestor.isSection()) {
    ancestor = ancestor.getParentNode()
  }

  return ancestor?.getLayerUUID() ?? null
}
